import CardTemplatePreview from './CardTemplatePreview';

export default CardTemplatePreview;
